import { apiClient } from "./client";
import type { Booking, TimeSlot } from "@abejon/shared";

interface BookingResponse {
  booking: Booking;
  serviceName?: string;
  businessName?: string;
  businessSlug?: string;
}

interface SlotsResponse {
  slots: TimeSlot[];
}

export async function getAvailableSlots(businessId: string, date: string, serviceId: string) {
  return apiClient<SlotsResponse>(
    `/availability/${businessId}/slots?date=${date}&serviceId=${serviceId}`
  );
}

export async function createBooking(data: {
  businessId: string;
  serviceId: string;
  date: string;
  startTime: string;
  guestName?: string;
  guestEmail?: string;
  guestPhone?: string;
  notes?: string;
}) {
  return apiClient<{ booking: Booking }>("/bookings", {
    method: "POST",
    body: data,
  });
}

export async function getBooking(id: string) {
  return apiClient<BookingResponse>(`/bookings/${id}`);
}

export async function cancelBooking(id: string) {
  return apiClient<{ booking: Booking }>(`/bookings/${id}/cancel`, {
    method: "PATCH",
  });
}

export async function lookupGuestBooking(email: string, code: string) {
  return apiClient<{ bookings: (Booking & { serviceName: string; businessName: string; businessSlug: string })[] }>(
    `/bookings/lookup?email=${encodeURIComponent(email)}&code=${encodeURIComponent(code)}`
  );
}

export async function getMyBookings(filters?: {
  page?: number;
  limit?: number;
}) {
  const params = new URLSearchParams();
  if (filters?.page) params.set("page", String(filters.page));
  if (filters?.limit) params.set("limit", String(filters.limit));
  const qs = params.toString();
  return apiClient<{
    bookings: (Booking & { serviceName: string; businessName: string; businessSlug: string })[];
    page: number;
    limit: number;
  }>(`/users/me/bookings${qs ? `?${qs}` : ""}`);
}

export async function getBusinessBookings(filters?: {
  date?: string;
  status?: string;
  page?: number;
  limit?: number;
}) {
  const params = new URLSearchParams();
  if (filters?.date) params.set("date", filters.date);
  if (filters?.status) params.set("status", filters.status);
  if (filters?.page) params.set("page", String(filters.page));
  if (filters?.limit) params.set("limit", String(filters.limit));
  const qs = params.toString();
  return apiClient<{
    bookings: (Booking & { serviceName: string })[];
    page: number;
    limit: number;
  }>(`/bookings${qs ? `?${qs}` : ""}`);
}

export async function completeBooking(id: string) {
  return apiClient<{ booking: Booking }>(`/bookings/${id}/complete`, {
    method: "PATCH",
  });
}

export async function markNoShow(id: string) {
  return apiClient<{ booking: Booking }>(`/bookings/${id}/no-show`, {
    method: "PATCH",
  });
}
